function getFragmentShader(uniforms, isPoints, alphaTest = "0.01") {
  const hasTexture = Boolean(uniforms.u_texture);

  const defaultAttrs = `
      precision mediump float;
      in vec4 vColor;
      in float clip_y;
      in float clip_y0;
      in float clip_y1;
      out vec4 fragColor;
  `;

  const alphaTestCheck = `
      if (collapseTexture < 0.5 && texture(u_texture, uv).w < ${alphaTest}) {
        discard;
      }
  `;

  const clip = `
      if (clip_y < clip_y0 || clip_y > clip_y1) {
        discard;
      }
  `;

  if (hasTexture) {
    return `
      ${defaultAttrs}
      uniform sampler2D u_texture;
      in vec4 vUv;
      in float collapseTexture;

      void main() {
        ${clip}
        vec2 uv = vUv.xy ${isPoints ? "+ vUv.zw * gl_PointCoord" : ""};
        ${alphaTest ? alphaTestCheck : ""}
        fragColor = vec4(vColor.xyz, vColor.w * (collapseTexture > 0.5 ? 1. : texture(u_texture, uv).w));
      }
  `;
  }

  return `
        ${defaultAttrs}
        void main() {
          ${clip}
          fragColor = vec4(vColor.xyz, vColor.w);
        }
`;
}

export default getFragmentShader;
